import { Divider, Grid, IconButton, Button } from '@material-ui/core';
import {
  Add as AddIcon,
  Edit as EditIcon,
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  Star,
} from '@material-ui/icons';
// import StarIcon from '@material-ui/icons/Star';
// import StarBorderIcon from '@material-ui/icons/StarBorder';
import { getCompetenceProById } from '@webapps/business';
import {
  Modal,
  Table,
  TableBody,
  TableButton,
  TableCell,
  TableContainer,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  TableRowExpan,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import AddCompetence from './AddCompetence';
import theme from './theme';
import AddCompetenceWithFranceTravail from './AddCompetenceWithFranceTravail';

const {
  colors: { background },
} = theme;

const CompetenciesPro = ({ allSkills = [], refetch }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [addCompetencePro, setAddCompetencePro] = useState(false);
  const [idEdit, setIdEdit] = useState(null);
  const [JobDomainIdForModal, setJobDomainIdForModal] = useState("");
  const [JobSectorIdForModal, setJobSectorIdForModal] = useState("");
  const [JobIdForModal, setJobIdForModal] = useState("");
  const [editCategory, setEditCategory] = useState(false);

  const handleOpenAddCompetencePro = () => {
    setAddCompetencePro(true);
  };
  const handleCloseAddCompetencePro = () => {
    setIdEdit(null);
    setAddCompetencePro(false);
    setJobDomainIdForModal("");
    setJobSectorIdForModal("");
    setJobIdForModal("");
    setEditCategory(false);
  };

  const {
    data: competencePro,
    isLoading,
    refetch: fetchCompetencePro,
  } = useQuery(getCompetenceProById, {
    key: ['compProOnStudentProfil', idEdit],
    variables: { id: idEdit },
    enabled: true,
  });

  const openEdit = (id) => {
    setIdEdit(id);
    fetchCompetencePro();
    handleOpenAddCompetencePro();
  };

  const handleEditCategory = (id, label, skills) => {


    setAddCompetencePro(true);
    setJobDomainIdForModal(skills?.[0]?.category?.domain?.id);
    setJobSectorIdForModal(skills?.[0]?.category?.skill_category_id);
    setJobIdForModal(skills?.[0]?.jobSectorSkill?.job?.ogr);
    setEditCategory(true)

  };





  const starsCounter = (value) => {
    switch (value) {
      case 1:
        return (
          <>
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
          </>
        );
      case 2:
        return (
          <>
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
          </>
        );
      case 3:
        return (
          <>
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
          </>
        );
      case 4:
        return (
          <>
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
          </>
        );
      case 5:
        return (
          <>
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
          </>
        );
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.editContainer}>
        <div className={global.title}>
          <FormattedMessage id="student.profil.competencesPro.title" />{' '}
          {'(' + allSkills?.length + ')'}
        </div>
        <div>
          <IconButton
            onClick={handleOpenAddCompetencePro}
            size="small"
            style={{
              margin: '3px 10px',
              borderRadius: '20px',
              border: '1px solid #C0D9FF',
              backgroundColor: '#F3F7FF',
              width: '30px',
              display: 'flex',
              justifyContent: 'center',
              height: '30px',
              alignItems: 'center',
              cursor: 'pointer',
            }}
          >
            <AddIcon fontSize="small" style={{ color: '#5A6DA1' }} />
          </IconButton>
        </div>
      </div>
      {!allSkills?.length ? (
        <div
          className={cx(css({
            textAlign: 'center',
            marginTop: spacing(2),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '190px',
          }), global.infoText)}
        >
          <FormattedMessage id="noElements" />
        </div>
      ) : (
        <TableContainer className={css({ marginBottom: spacing(0) })}>
          <Table>
            <TableHead>
              <TableHeadRow></TableHeadRow>
            </TableHead>
            <TableBody>
              {allSkills?.map(({ id, label, skills }) => (
                <TableRowExpan key={id}>
                  {({ Row, RowData, RowHidden, expanded, toggle }) => (
                    <Row>
                      <RowData onClick={toggle} style={{ cursor: 'pointer' }}>
                        <TableCell
                          style={{
                            padding: spacing(0), color: '#5A6DA1',
                          }}
                          className={classes.tableCell}
                          sx={{
                            borderBottom: '1px solid #C0D9FF', // Couleur constante
                          }}
                        >
                          {label}
                        </TableCell>
                        <TableCell
                          align="right"
                          className={css({
                            whiteSpace: 'nowrap',
                            paddingRight: spacing(0),
                            borderBottom: '1px solid #C0D9FF',

                          })}
                        >
                          <TableButton
                            className={css({
                              '&:hover': { backgroundColor: 'white' },

                            })}
                            disableRipple
                          >
                            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                          </TableButton>
                        </TableCell>
                      </RowData >
                      <RowHidden>
                        <Button
                          variant="outlined"
                          size="small"
                          style={{

                            color: '#5A6DA1',
                            borderColor: '#C0D9FF',
                            borderRadius: '6px',
                            marginBottom: spacing(3),

                          }}
                          onClick={() => handleEditCategory(id, label, skills)}
                        >
                          Modifier la catégorie
                        </Button>
                        <Grid container spacing={2}
                          className={
                            css({
                              marginBottom: 12
                            })
                          }
                        >
                          <Grid
                            item
                            xs={5}
                            md={4}
                            className={cx(css({
                              textAlign: 'left',
                              color: '#152652',
                              '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
                              '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
                            }))}>
                            <span

                            >Compétences</span>

                          </Grid>
                          <Grid
                            item
                            xs={5}
                            md={4}
                            className={css({
                              textAlign: 'left',
                              color: '#152652',
                              paddingLeft: "20px",
                              '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
                              '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
                            })}
                          >
                            Niveau d'expérience
                          </Grid>
                        </Grid>
                        {skills?.map(
                          ({ id: idSkill, label: labelSkill, level }) => (
                            <div
                              key={idSkill}
                              className={css({
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginTop: spacing(1),
                                marginBottom: spacing(1),
                                '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
                                '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
                                color: '#152652',
                              })}
                            >
                              <Grid
                                container
                                spacing={2}
                                style={{
                                  alignItems: 'center',
                                }}
                              >
                                <Grid item xs={5} md={4}>
                                  {labelSkill}
                                </Grid>
                                <Grid
                                  item
                                  xs={5}
                                  md={4}
                                  className={css({
                                    padding: "8px 8px 8px 20px !important",
                                  })}
                                >
                                  {starsCounter(level)}
                                </Grid>
                                <Grid
                                  item
                                  md={4}
                                  xs={2}
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    paddingRight: spacing(1),
                                  }}


                                >
                                  <IconButton
                                    onClick={() => openEdit(idSkill)}
                                    size="small"
                                    style={{
                                      margin: '0 3px',
                                      borderRadius: '20px',
                                      border: '1px solid #C0D9FF',
                                      backgroundColor: '#F3F7FF',
                                      width: '30px',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      height: '30px',
                                      alignItems: 'center',
                                      cursor: 'pointer',
                                    }}
                                  >
                                    <EditIcon
                                      fontSize="small"
                                      style={{ color: '#5A6DA1' }}
                                    />
                                  </IconButton>
                                </Grid>
                              </Grid>
                            </div>
                          )
                        )}
                      </RowHidden>
                    </Row>
                  )}
                </TableRowExpan>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Modal
        onCancel={handleCloseAddCompetencePro}
        open={addCompetencePro}
        title={idEdit ? <FormattedMessage id="editCompetencePro" /> : < FormattedMessage id="addCompetencePro" />}
      >
        <AddCompetenceWithFranceTravail
          close={handleCloseAddCompetencePro}
          idEdit={idEdit}
          initialData={{
            ...competencePro,
            job: {
              id: JobIdForModal,
              bigDomain: {
                code: JobDomainIdForModal
              },
              jobSector: {
                skill_category_id: JobSectorIdForModal
              },
            }
          }}
          editCategory={editCategory}
          isLoadingEdit={isLoading}
          allSkills={allSkills}
          refetch={refetch}
        />
      </Modal>
    </div >
  );
};

const styles = ({ spacing }) => ({
  container: {
    background,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
  },
  editContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  stars: {
    color: '#005CEF',
  },
  tableCell: {
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    borderBottom: '1px solid #C0D9FF',
  },
});

CompetenciesPro.propTypes = {
  allSkills: PropTypes.array,
  refetch: PropTypes.func,
};

export default CompetenciesPro;
